export default "__VITE_ASSET__8YOeUtc4__"